// removed by extract-text-webpack-plugin
module.exports = {"loader":"_3h2Zp8PvZtQReNa6k_6IAp","innerLoader":"_1foJgs4CFS02ZFsF3eZDBL","spinner":"_3ZNA7YciCBDwSotc2IMjyS","rotate":"_3Ayc-uj66VKquEmGHMORQz"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Loader/Loader.pcss
// module id = 970
// module chunks = 0